import { render, staticRenderFns } from "./KnowledgeContentMultipleFolderSelector.vue?vue&type=template&id=ce1e49c8&scoped=true&"
import script from "./KnowledgeContentMultipleFolderSelector.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentMultipleFolderSelector.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeContentMultipleFolderSelector.vue?vue&type=style&index=0&id=ce1e49c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1e49c8",
  null
  
)

export default component.exports